class ToastContainerController {
  constructor(toastService) {
    this.toastService = toastService;
  }
}

ToastContainerController.$inject = ['toastService'];

module.exports = ToastContainerController;
